import { defer, EMPTY, from, } from "rxjs";
import { map, materialize, mergeMap } from "rxjs/operators";
export function concatMapEager(project, concurrency) {
    return (source) => defer(() => {
        let activeIndex = 0;
        const innersByIndex = new Map();
        function flush() {
            const values = [];
            let activeInner = innersByIndex.get(activeIndex);
            while (activeInner) {
                values.push(...activeInner.values);
                activeInner.values.length = 0;
                if (activeInner.complete) {
                    innersByIndex.delete(activeIndex);
                    activeInner = innersByIndex.get(++activeIndex);
                }
                else {
                    break;
                }
            }
            return values;
        }
        return source.pipe(mergeMap((value, index) => from(project(value, index)).pipe(materialize(), map((notification) => ({
            index,
            notification,
        }))), concurrency), mergeMap(({ index, notification }) => {
            let inner = innersByIndex.get(index);
            if (!inner) {
                inner = { complete: false, index, values: [] };
                innersByIndex.set(index, inner);
            }
            switch (notification.kind) {
                case "N":
                    inner.values.push(notification.value);
                    break;
                case "C":
                    inner.complete = true;
                    break;
                case "E":
                    return notification.toObservable();
                default:
                    break;
            }
            if (inner.index !== activeIndex) {
                return EMPTY;
            }
            return flush();
        }));
    });
}
//# sourceMappingURL=concatMapEager.js.map